<template>
  <div id="tabs-sidenav">
    <Tabs :labels="[$t('layout'), $t('config')]">
      <Layout
        :id="active.id"
        :title="active.title"
        :items="active.items"
        :currentView="currentView"
        :options="options[currentView]"
      />
      <Content :id="active.id" :currentView="currentView" />
    </Tabs>
  </div>
</template>

<script>
import Mixin from '@/components/sidenav/landing/Mixin.js'
import Content from '@/components/sidenav/landing/tabs/Content'
import Layout from '@/components/sidenav/landing/tabs/Layout'

export default {
  name: 'TabsSideNav',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.tabs-side-nav' },
  mixins: [Mixin],
  components: { Content, Layout },
}
</script>
